import { helpers, required } from "@vuelidate/validators";
import validationJson from "~/static/locale/it/validation.json";
import { DateTime } from "luxon";

const { locale } = await useLocale("validation");

export default {
  documentExpire: {
    required: helpers.withMessage(
      () => locale?.value?.required ?? validationJson.required,
      required,
    ),
    minValue: helpers.withMessage(
      () => locale?.value?.document_expire ?? validationJson.document_expire,
      (value: string) => {
        return DateTime.fromFormat(value, "dd/MM/yyyy") >= DateTime.now();
      },
    ),
    maxValue: helpers.withMessage(
      () => locale?.value?.document_expire ?? validationJson.document_expire,
      (value: string) => {
        return (
          DateTime.fromFormat(value, "dd/MM/yyyy") <=
          DateTime.now().plus({ years: 11 })
        );
      },
    ),
  },
};
